import { Role } from '@caresend/types';
import { shiftsListHeadingValues } from './components/shiftDetails.js';
import { getJobDetailsHeading } from './helper.js';
import { PortalRouteName } from './model.js';
import { getStore } from '../../../store/helpers/initStore.js';

/* eslint-disable max-len */
const portalChildRoutes = [
    {
        path: '/itinerary/:itineraryID/'
            /** Parameters used to find a route and workflow item */
            + ':childRouteName?/:wfStoreRef?/:wfReferenceID?/'
            + ':wfItemID?/:wfContext?',
        name: PortalRouteName.ITINERARY,
        props: true,
        meta: {
            authRequired: true,
            minimizableNavBar: true,
            portal: {
                lockMap: 'collapsed',
                displayLegend: true,
                noPanelPadding: true,
                panelScrollLock: true,
            },
        },
        component: () => import('../../../components/specific/portal/components/Portal/components/ItineraryControlPanel/ItineraryControlPanel.vue.js'),
    },
    {
        path: '/job/:shiftID',
        name: PortalRouteName.JOB_DETAILS,
        props: true,
        meta: {
            authRequired: true,
            minimizableNavBar: true,
            portal: {
                lockMap: 'collapsed',
                noPanelPadding: true,
                panelScrollLock: true,
            },
            heading: getJobDetailsHeading,
        },
        component: () => import('../../../components/specific/portal/components/Portal/components/Shifts/ShiftDetails.vue.js'),
    },
    {
        path: '/jobs',
        name: PortalRouteName.JOBS,
        meta: {
            authRequired: true,
            minimizableNavBar: true,
            portal: {
                noPanelPadding: true,
                panelScrollLock: true,
            },
            heading: shiftsListHeadingValues,
        },
        component: () => import('../../../components/specific/portal/components/Portal/components/Shifts/ShiftsList.vue.js'),
    },
    {
        path: '/orders',
        name: PortalRouteName.ORDERS,
        meta: {
            authRequired: true,
            minimizableNavBar: true,
            portal: {
                noPanelPadding: true,
                panelScrollLock: true,
            },
        },
        beforeEnter: (_to, _from, next) => {
            var _a;
            return ((_a = getStore().state.auth.user) === null || _a === void 0 ? void 0 : _a.role) !== Role.NURSE
                ? next()
                : next(false);
        },
        component: () => import('../../../components/specific/portal/components/Portal/components/OrdersList/OrdersList.vue.js'),
    },
    {
        path: '/procedure/:procedureID/:view?',
        name: PortalRouteName.PROCEDURE,
        props: true,
        meta: {
            authRequired: true,
            minimizableNavBar: true,
            portal: {
                lockMap: 'full',
                noPanelPadding: true,
                panelScrollLock: true,
            },
        },
        component: () => import('../../../components/specific/ProcedureDetails/ProcedureDetails/PortalProcedurePage.vue.js'),
    },
];
const getPortalChildRoutes = () => portalChildRoutes;

export { getPortalChildRoutes };
